
export const woodDoor = "WD Door"
export const hollowMetalDoor = "HM Door"
export const aluminumDoor = "AL Door"
export const existingDoor = "Ex Door"
export const hollowMetalFrame = "HM Frame"
export const existingFrame = "Ex Frame"
export const woodFrame = "WD Frame";
export const aluminumFrame = "AL Frame";

export const kdFrameConstruction = "KD"
export const weldFrameConstruction = "WELD"

export const woodPLAM = "PLAM"
export const woodMaterials = [
    "Hardboard",
    "Natural Birch",
    "White Birch",
    "White Oak",
    "Red Oak",
    "Natural Maple",
    "White Maple",
    "White Ash",
    "Mahogany",
    "Cherry",
    "Walnut",
    woodPLAM,
]

export const labels = ["20 Min", "45 Min", "90 Min", "3 HR"]
export const frameSeries = [aluminumFrame, existingFrame, hollowMetalFrame, woodFrame]
export const doorSeries = [aluminumDoor, existingDoor, hollowMetalDoor, woodDoor]